import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { AdminEntity } from "../../entity";

export class GetAllAdminDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => AdminEntity)
  data!: AdminEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
